import {
  saveListUsers,
  saveSelectedUser,
  saveCountUsers,
  saveCountWithoutTransactions,
  saveYearsListByUser
} from "../Infrastructure/Users.store";
import {
  deleteUserLogic,
  getUserLogic,
  getUsersLogic,
  updateEnabledLogic,
  updateLumensLogic,
  updateUserStatusLogic,
  patchUserLogic,
  getYearsByUserLogic 
} from "./Users.logic";

export async function getUsers(params) {
  const {
    count_without_transactions,
    count,
    resources: users,
  } = await getUsersLogic(params);
  saveListUsers(users);
  saveCountUsers(count);
  saveCountWithoutTransactions(count_without_transactions);
}

export async function getUser(id) {
  const user = await getUserLogic(id);
  saveSelectedUser(user);
}

export async function deleteUser(id, params) {
  await deleteUserLogic(id, params);
  const user = await getUserLogic(id);
  saveSelectedUser(user);
}

export async function updateEnabledUser(id, params) {
  await updateEnabledLogic(id, params);
  const user = await getUserLogic(id);
  saveSelectedUser(user);
}

export async function updateLumens(id, params) {
  await updateLumensLogic(id, params);
  const user = await getUsersLogic(id);
  saveSelectedUser(user);
}

export async function updateUserStatus(id, verifiedStatus) {
  await updateUserStatusLogic(id, verifiedStatus); 
  const user = await getUserLogic(id); 
  saveSelectedUser(user); 
}
// export async function patchUser(id, params) {
//   try {
//     const response = await patchUserLogic(id, params);
//     console.log("Respuesta:", response);
//     const isSuccess =
//       response === true ||
//       response?.status === 204 ||
//       response?.status === 200 ||
//       response?.status === 201;
//     if (isSuccess) {
//       const user = await getUserLogic(id);
//       saveSelectedUser(user);
//       return true; 
//     }
//     console.warn("patchUser no devolvió  success válido:", response);
//     return false;
//   } catch (error) {
//     console.error("Error:", error);
//     return false;
//   }
// }
export async function patchUser(id, params) {
  console.log("iniciando patchUser");
  console.log("parámetros recibidos", { id, params });

  try {
    console.log("enviando solicitud patch al backend");
    const response = await patchUserLogic(id, params);
    console.log("respuesta recibida del backend", response);

    const isSuccess =
      response === true ||
      response?.status === 204 ||
      response?.status === 200 ||
      response?.status === 201;

    console.log("succes:", isSuccess);

    if (isSuccess) {
      console.log("obteniendo usuario actualizado");
      const user = await getUserLogic(id);
      console.log("usuario actualizado obtenido", user);

      saveSelectedUser(user);
      console.log("usuario guardado en store correctamente");
      return true;
    }

    console.warn("patchUser no devolvió success válido", response);
    return false;
  } catch (error) {
    console.error("error en patchUser", error);
    return false;
  }
}

export async function getYearsByUser(id) {
  const years = await getYearsByUserLogic(id);
  saveYearsListByUser(years || []);
  return years;
}